import { useState, useEffect } from 'react';

const usePromise = <T, E extends unknown>(
  promiseFactory: () => Promise<T>,
  defaultValue?: T,
  deps: React.DependencyList = [],
) => {
  const [data, setData] = useState<T | undefined>(defaultValue);
  const [error, setError] = useState<E | undefined>(undefined);
  const [isLoading, setIsLoading] = useState<boolean>(true);

  useEffect(() => {
    const fetchData = async () => {
      setIsLoading(true);
      try {
        const response = await promiseFactory();
        setData(response);
        setError(undefined);
      } catch (error) {
        setError(error as E);
        setData(defaultValue);
      } finally {
        setIsLoading(false);
      }
    };

    fetchData();
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, deps);

  return { data, error, isLoading };
};

export default usePromise;
